module.exports = __webpack_public_path__ + "img/race-flag.ff0efbf8.svg";